import { ThemeProvider } from "@mui/material";
import MainRouter from "./router";
import theme from "./styles/theme";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import store from "./redux/store";

import "./styles/global.css";
import "remixicon/fonts/remixicon.css";
import "react-toastify/dist/ReactToastify.css";
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <HelmetProvider>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <MainRouter />
        </ThemeProvider>
      </Provider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        draggable
        closeOnClick
        pauseOnHover
        theme="colored"
        limit={3}
      />
    </HelmetProvider>
  );
}

export default App;
